module.exports = __webpack_public_path__ + "static/img/video8.0312e63d.png";